import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getDistanceById } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useGetRowData = (rowId?: number | null) => {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery({
    queryKey: ['distances', 'get', rowId],
    queryFn: async () => {
      const { data } = await getDistanceById(rowId);
      return data;
    },
    enabled: !!rowId,
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('fetchError')
      });
    }
  });

  return { isFetching, data };
};

export default useGetRowData;
